import Bitmap from "./bitmap";
import Color from "./models/color";
import { getBlockPack } from "./packs/blocks/BlockPackFactory";

/**
 * @deprecated Use getBlockPackFromStorage() and IBlockPack.drawBlock() instead
 * This function is kept for backward compatibility and delegates to the default pack.
 */
function drawBlock(bit: Bitmap, x: number, y: number, side: number, width: number, color: Color, to: number[]){
	const pack = getBlockPack("default");
	pack.drawBlock(bit, x, y, side, width, color, to);
}

/**
 * @deprecated These functions have been moved to DefaultBlockPack
 * Kept for backward compatibility only
 */
function drawRawBlockCorner(bit: Bitmap, x: number, y: number, side: number, width: number, color: Color, to: number[]): void {
	const pack = getBlockPack("default");
	pack.drawBlock(bit, x, y, side, width, color, to);
}

/**
 * @deprecated These functions have been moved to DefaultBlockPack
 * Kept for backward compatibility only
 */
function drawRawBlock(bit: Bitmap, x: number, y: number, side: number, width: number, color: Color): void {
	const pack = getBlockPack("default");
	// Draw without corner connections by passing empty to array
	pack.drawBlock(bit, x, y, side, width, color, [0, 0, 0, 0]);
}

function drawCanvas(bit: Bitmap, x: number, y: number, w: number, h: number, color: Color): void {
	bit.drawShape([
		x, y,
		x + w, y,
		x + w, y + h,
		x, y + h
	], color.shade(4))
}

function createCanvas(width: number = 0, height: number = 0): HTMLCanvasElement {
	const canvas = document.createElement('canvas');
	canvas.width = width;
	canvas.height = height;
	return canvas;
}

export { drawRawBlock, drawRawBlockCorner, drawBlock, drawCanvas, createCanvas };